import React from 'react';
import EnquirySuccessPNG from './images/enq-success.png';
import Heading from 'components/Heading/Heading';
import Button from 'components/Button/Button';

import { Row, Col } from 'antd';

import styled from 'styled-components/macro';

const EnquirySubmitted = ({ className }) => (
  <Row className={className} type="flex" justify="center" align="middle">
    <Col span={20} lg={16} className={className}>
      <img alt="enquiry big email" src={EnquirySuccessPNG} />
      <Heading size="sub" align="center" color="darkGrey">
        Thank you! Your enquiry has been submitted successfully.
      </Heading>
      <Row type="flex" justify="center">
        <Col span={16}>
          <Button size="large" type="secondary" style={{width:'100%'}} toUrl="/">
            Back to Home 
          </Button>
        </Col>
      </Row>
    </Col>
  </Row>
);

const StyledEnquirySubmitted = styled(EnquirySubmitted)`
  text-align: center;
  width: 90%;
  margin: 32px auto;
  min-height: 409px;
  img {
    width: 100%;
    margin-bottom: 24px;
  }

  @media (min-width: 992px) {
    width: 68%;
  }
`;

export default StyledEnquirySubmitted;
